import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ApiService } from '../utilities/services/api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { BaseService } from '@app/system/services/base.service';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { PlaylistFormsComponent } from '../playlist-forms/playlist-forms.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';

@Component({
	selector: 'app-playlist-detail',
	templateUrl: './playlist-detail.component.html',
	styleUrls: ['./playlist-detail.component.scss']
})
export class PlaylistDetailComponent implements OnInit {

	@Input() resourceDetail: any = {};
	@Input() additionalData;
	@Output() profileDetail = new EventEmitter<boolean>();

	currentUser;
	loader = false;
	disableDrag = true;

	constructor(
		public gfService: GlobalFunctionService,
		private popup: MatDialog,
		private apiService: ApiService,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private baseService: BaseService,
		private appInit: AppInitializerService,
		private resourceApiService: ResourceApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		if (this.resourceDetail.infoFields && Array.isArray(this.resourceDetail.infoFields.resourceList)) {
			this.dataBuild(this.resourceDetail.infoFields.resourceList);
		}
		// this.updateReadStatus(Number(this.resourceDetail.completedPercent));
		if (this.resourceDetail && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.organize) {
			this.disableDrag = false;
		}
		let prevDisableState = this.disableDrag;
		this.detectDevice.resolutionState$.subscribe((device) => {
			if (device.deviceType === 'mobile') {
				this.disableDrag = true;
			} else if (!prevDisableState) {
				this.disableDrag = prevDisableState;
			}
		});
	}

	getUsersProfile(data) {
		if (data && Array.isArray(data.authors)) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				autoFocus: false,
				data: {
					action: 'users',
					popup: true,
					usersList: data.authors
				},
				disableClose: true,
				maxWidth: '800px'
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result) {
				}
			});

		}
	}

	dataBuild(records) {
		this.resourceDetail.playlistData = [];
		for (const record of records) {
			record.dragging = false;
			const data = record.resourceID;
			if (this.resourceDetail.playlistReadData && this.resourceDetail.playlistReadData.length) {
				const playlistRead = this.resourceDetail.playlistReadData.find(items => items.resourceID === data.resourceID);
				if (playlistRead) {
					data.read = playlistRead.read;
				}
			}
			data.resourceType = this.baseService.referenceType('resourceType', data.resourceTypeID);
			delete data.status;
			let finalData;
			if (data.resourceType) {
				if (data.resourceType.key === 'answer') {
					const cardData: QuestionCard = {
						title: data.title,
						date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: ''
					};
					if (data.authors && data.authors.length) {
						cardData.thumbnail = data.authors[0].profilePicURL;
						cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
							? ' ' + data.authors[0].lastName
							: ''}`;
						if (data.authors.length > 1) {
							cardData.usersCount = (data.authors.length - 1);
						}
					}
					finalData = cardData;
				} else if (['internalEvent', 'externalEvent'].includes(data.resourceType.key)) {
					const cardData: EventCard = {
						thumbnail: '',
						title: data.title,
						eventType: (data.resourceType && data.resourceType.key) ? data.resourceType.key : null
					};
					if (!data.description) {
						delete data.description;
					}
					if (data.resourceType) {
						if (data.infoFields) {
							if (data.resourceType.key === 'internalEvent') {
								if (data.infoFields.time) {
									cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
								}
								if (data.infoFields.startDate && data.infoFields.endDate) {
									const startDate: any = new Date(data.infoFields.startDate);
									const endDate: any = new Date(data.infoFields.endDate);
									startDate.setHours(0, 0, 0, 0);
									endDate.setHours(0, 0, 0, 0);
									if (Date.parse(startDate) === Date.parse(endDate)) {
										cardData.date = `${this.gfService.dateFormat(data.infoFields.startDate, 'd')} ${this.gfService.dateFormat(data.infoFields.startDate, 'MMM')}`;
									} else {
										cardData.date = `${this.gfService.dateFormat(data.infoFields.startDate, 'd')} ${this.gfService.dateFormat(data.infoFields.startDate, 'MMM')} - ${this.gfService.dateFormat(data.infoFields.endDate, 'd')} ${this.gfService.dateFormat(data.infoFields.endDate, 'MMM')}`;
									}
									const date: any = new Date(data.infoFields.endDate);
									const timeDate = new Date(data.infoFields.time);
									date.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds(), timeDate.getMilliseconds());
									if (Date.now() > Date.parse(date)) {
										cardData.dateClasses = ['expired'];
									}
								}
							} else {
								if (data.infoFields.startDate) {
									cardData.date = this.gfService.dateFormat(data.infoFields.startDate, 'd MMM');
								}
								const date: any = new Date(data.infoFields.startDate);
								if (Date.now() > Date.parse(date)) {
									cardData.dateClasses = ['expired'];
								}
							}
						}
						cardData.type = data.resourceType.caption;
					}

					finalData = cardData;
				} else {
					const cardData: ContentImageCard = {
						removable: false,
						title: data.title,
						date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: '',
						type: data.resourceType.caption,
						read: data.read || false
					};
					finalData = cardData;
				}
			}
			if (data.resource.hasOwnProperty('duration')) {
				finalData.duration = data.resource.duration;
			}
			let userID = null;
			if (data.authors && data.authors.length) {
				if (data.resourceType && ['knowledgeBead'].includes(data.resourceType.key)) {
					finalData.userThumbnail = data.authors[0].profilePicURL || '';
					finalData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
						? ' ' + data.authors[0].lastName
						: ''}`;
					if (data.authors.length > 1) {
						finalData.creator = `${finalData.creator} + ${data.authors.length - 1}`;
					}
				}
				userID = data.authors[0].userID;
			}
			finalData.userID = userID;
			if (data.stats && Object.keys(data.stats).length > 0 && data.settings) {
				if (data.settings.rating) {
					finalData.rating = data.stats.avgRating || 0;
				}
				if (data.settings.commenting) {
					finalData.commentsCount = data.stats.conversationCount || 0;
				}
			}
			if (data.resource && data.resource.thumbnail && data.resourceType && data.resourceType.key !== 'answer') {
				finalData.thumbnail = data.resource.thumbnail;
			}
			if (data.resourceFormat) {
				data.resourceFormat = this.baseService.referenceType('resourceFormat', data.resourceFormat);
				finalData.format = data.resourceFormat.key;
				if (finalData.thumbnail === '') {
					data.thumbnail = data.resourceFormat.image;
				}
			}
			if (data.resourceType && data.resourceType.key === 'answer') {
				delete data.description;
			}
			if (this.resourceDetail.resourceAction.itemDelete) {
				finalData.removable = true;
			} else {
				finalData.removable = false;
			}
			if (data.read) {
				finalData.watched = true;
			} else {
				finalData.watched = false;
			}
			finalData.streaming = false;
			this.resourceDetail.playlistData.push(this.gfService.JSONMerge(finalData, data));
		}
	}

	drop(event: CdkDragDrop<string[]>) {
		if (navigator.onLine) {
			if (this.resourceDetail.playlistData.length > 1) {
				if (event.currentIndex !== event.previousIndex) {
					moveItemInArray(this.resourceDetail.playlistData, event.previousIndex, event.currentIndex);
					this.update('update');
				}
			}
		}
	}

	cdkDragStarted(event, data) {
		data.dragging = true;
	}

	cdkDragEnded(event, data) {
		data.dragging = false;
	}

	detail(data) {
		if (navigator.onLine) {
			for (const data of this.resourceDetail.playlistData) {
				data.streaming = false;
				// data.watched = false;
			}
			data.streaming = true;
			// let type = 'assign_to_me';
			// if (data.createdBy === this.currentUser.userID) {
			// 	type = 'assign_by_me';
			// }
			this.loadResource(data.resourceID);
		}
	}

	profileInfo(data) {
		this.profileDetail.emit(data);
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title: this.locale.translate('delete'),
				content: this.locale.translate('delete_playlist_text'),
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'delete') {
						data.deleting = true;
						this.resourceDetail.playlistData.splice(additionalInfo.index, 1);
						this.update(action);
					}
				}
			}
		});
	}

	update(action) {
		if (navigator.onLine) {
			const resourceList = [];
			this.loader = true;
			if (this.resourceDetail.playlistData && this.resourceDetail.playlistData.length) {
				this.resourceDetail.playlistData.map((resp, index) => {
					resourceList.push(
						{
							index,
							resourceID: resp.resourceID
						}
					);
				});
			}
			const apiData: any = {
				infoFields: {
					resourceList
				}
			};
			if (!resourceList.length) {
				apiData.infoFields = {};
			}
			const headers: any = {};
			this.apiService.updatePlaylist(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					if (action !== 'update') {
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('resource_delete_from_playlist'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.loader = false;
				});
		}
	}

	loadResource(resourceID: number) {
		if (this.resourceDetail.playlistData && this.resourceDetail.playlistData.length) {
			for (const data of this.resourceDetail.playlistData) {
				data.changed = false;
			}
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('../../resource/resource-detail/resource-detail.component'),
				componentData: [
					// {
					// 	variableName: 'type',
					// 	value: type
					// },
					{
						variableName: 'actualResourceID',
						value: resourceID
					},
					{
						variableName: 'headerType',
						value: 'playlist'
					},
					{
						variableName: 'playlistData',
						value: this.resourceDetail.playlistData
					},
					{
						variableName: 'actionFrom',
						value: 'playlist_item'
					},
					{
						variableName: 'playlistParentData',
						value: this.resourceDetail
					},
					{
						variableName: 'addScrollClassToPopup',
						value: false
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
				// let count = 0;
				// for (const data of this.resourceDetail.playlistData) {
				// 	console.log(data, data.watched, data.changed);
				// 	if (data.watched && data.changed) {
				// 		data.read = true;
				// 		count += 1;
				// 	}
				// }
				// this.updateReadStatus((count / this.resourceDetail.playlistData.length) * 100);
				this.updateReadStatus();
			}
		});
	}

	updateReadStatus() {
		if (!this.resourceDetail.read) {
			this.loader = true;
			const headers: any = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			this.resourceApiService.getResourceReadStatus(this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					if (response) {
						if (response.playlist && response.playlist.length && this.resourceDetail.playlistData && this.resourceDetail.playlistData.length) {
							let count = 0;
							for (const data of response.playlist) {
								if (data.read) {
									const item = this.resourceDetail.playlistData.find(items => items.resourceID === data.resourceID);
									if (item) {
										count += 1;
										item.read = data.read;
									}
								}
							}
							if (count) {
								const percentage = (count / this.resourceDetail.playlistData.length) * 100;
								if (percentage !== this.resourceDetail.completedPercent) {
									const apiData = {
										type: 1,
										completedPercent: percentage
									};
									const readLogHeaders: any = {};
									this.resourceApiService.addReadLog(apiData, this.resourceDetail.resourceID, readLogHeaders).subscribe(
										(response) => {
											this.resourceDetail.read = response.read;
											this.resourceDetail.completedPercent = percentage;
											this.additionalData.read = response.read;
											if (response.read) {
												this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
											}
										},
										(error) => { }
									)
										.add(() => {
										});
								}
							}
						}
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.loader = false;
				});
		}
		// if (percentage && !this.resourceDetail.read) {
		// 	const apiData = {
		// 		type: 1,
		// 		percentage
		// 	};
		// 	const headers: any = {};
		// 	this.resourceApiService.addReadLog(apiData, this.resourceDetail.resourceID, headers).subscribe(
		// 		(response) => {
		// 			this.resourceDetail.read = response.read;
		// 			this.resourceDetail.completedPercent = percentage;
		// 		},
		// 		(error) => { }
		// 	)
		// 		.add(() => {
		// 			this.loader = false;
		// 		});
		// } else {
		// 	this.loader = false;
		// }
	}

	addPlaylistItem(actionEl?) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PlaylistFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'addPlaylistItem'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				if (this.resourceDetail.playlistData && this.resourceDetail.playlistData.length) {
					this.resourceDetail.playlistData = this.resourceDetail.playlistData.concat(result);
				} else {
					this.resourceDetail.playlistData = result;
				}
			}
		});
	}

}
